import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import { useForm } from "react-hook-form";

const DialogCreateFolder = (props) => {
  const { t, i18n } = useTranslation();
  // const [state, setState] = useState({
  //   open_dialog: false,
  // });
  const { register, handleSubmit, reset, setValue} = useForm();
  
  // console.log(props);
  useEffect(() => {
    // console.log("runn");
    // console.log(props, "effect");
    if(props.dialog_folder_type === "edit") {
      // console.log("runn", props.folder_edit_data);
      setValue("folder_name", props.folder_edit_data.folder_name);
    }
  },[props.dialog_folder_type, props.folder_edit_data]);

  const onHandleSubmit = (data) => {
    if (data.folder_name === "") {
      return;
    }
    if(props.dialog_folder_type === "edit") {
      props.onHandleEditFolder(data)
    }
    if(props.dialog_folder_type === "create") {
      props.onHandleCreateFolder(data)
    }
    // props.onHandleCreateFolder(data)
    reset();
  }

  // const onHandleEditFolder = (data) => {}
  const onHandleCloseDialogFolder = () => {
    props.handleCloseDialogFolder();
    reset();
  }
  return (
    <>
      
      <Dialog
        open={props.dialog_folder}
        fullWidth="true"
        maxWidth="sm"
        onClose={onHandleCloseDialogFolder}
      >
        <DialogTitle>{
          props.dialog_folder_type === "create" ? t("common.upload.createFolder") : t("common.upload.editFolder")
        }</DialogTitle>
        <form action="" onSubmit={handleSubmit(onHandleSubmit)}>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label={t("common.upload.yourFolderName")}
              type="text"
              fullWidth
              variant="outlined"
              {...register("folder_name")}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={onHandleCloseDialogFolder}
            >
              {t("common.close")}
            </Button>
            <Button type="submit">{t("common.confirm")}</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default DialogCreateFolder;
